import {i18n} from '~ui/components/PageBackgroundPopup/i18n';
import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';
import {minDelay} from '~ui/utils';

export const getBackgrounds = createThunk('backgrounds/get', (_, thunkAPI) => {
    const {sdk} = thunkAPI.extra;

    return minDelay(sdk.wiki.getPageBackgrounds(), 500).catch(
        makeThunkErrorHandler({
            name: 'get-backgrounds-error',
            title: i18n('get-backgrounds-error'),
        }),
    );
});
